import { useState, useEffect, useContext } from 'react';
import { Typography, Box, Stack, IconButton, Button } from '@mui/material';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
//import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useNavigate } from "react-router-dom";

import { getActions, getRate } from '../../services/booking'
import AddBooking from '../../components/AddBooking'
import userContext from '../../context/userContext'
import Menu from '../../components/Menu'
import Report from './report'
import FitView from '../../components/fitView'

import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import MoreTimeIcon from '@mui/icons-material/MoreTime';

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(utc);
//dayjs.extend(timezone);

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        height: 70,
        borderBottom: '1px solid black',
        width: '100%',
    },
    contentRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: 70,
        width: 100*48,
        position: 'relative',
        borderBottom: '1px solid black',
    },
    day: {
        textAlign: 'center',
        flexDirection: "column",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 50,
    },
    dateRound: {
        border: '1px solid black',
        borderRadius: 2,
        width: 30,
    },
    content: {
        width: '100%',
        overflow: 'hidden',
        overflowX: 'scroll',
    },
}


  const calculatePosition = (day, start, end) => {

    //console.log(day, start, end)
    const dayStart = dayjs(day).startOf('day');
    const startMinutes = dayjs(start).diff(dayStart, 'minute');
    const endMinutes = dayjs(end).diff(dayStart, 'minute');

    //const startMinutes = dayjs(start).utcOffset(0, true).diff(dayjs(dayStart), 'minute');
    //const endMinutes = dayjs(end).utcOffset(0, true).diff(dayjs(dayStart), 'minute');

        
    return {
      left: `${(startMinutes / (24 * 60)) * 100}%`,
      width: `${((endMinutes - startMinutes) / (24 * 60)) * 100}%`,
    };
  };

const transformData = (data, days) => {
    const _data = {}
    days.forEach(day => {
        _data[day] = data.filter(datum => {
            return dayjs(datum.from).isSame(dayjs(day), 'day')
        })
    })
    return _data
}

const getIntervals = () => {
    
    const intervals = [];
    
    const startTime = dayjs().startOf('day'); // Start at 00:00
    const endTime = dayjs().endOf('day'); // End at 24:00 (next day's 00:00)
    
    let currentTime = startTime;
    
    while (currentTime.isBefore(endTime) || currentTime.isSame(endTime)) {
      intervals.push(currentTime.format('HH:mm'));
      currentTime = currentTime.add(30, 'minute');
    }

    return intervals
}

const ButtonBar = ({view, setView, handleAddBookClick}) => {
    const handleClick = () => {
        setView(view === 'full' ? 'fit' : 'full')
    }
    return (
        <Box sx={{display: 'flex', mr: 2, flexDirection: 'row', justifyContent: 'flex-end'}}>
            <Button size="small" startIcon={<MoreTimeIcon/>} variant='contained' onClick={handleAddBookClick} sx={{mr: 5}}>Book</Button>
            <Button size="small" variant='contained' onClick={handleClick}> {view === 'full' ? <CloseFullscreenIcon/> : <OpenInFullIcon/>} </Button>
        </Box>
    )
}

const GanttDayRow = ({day}) => {
    return (
        <Box sx={styles.row}>
            <Stack direction="column" alignItems="center" justifyContent="center">
                <Typography sx={styles.dateRound}>{dayjs(day, 'YYYY-MM-DD').format('DD')}</Typography>
                <Typography>{dayjs(day, 'YYYY-MM-DD').format('ddd')}</Typography>
            </Stack>
        </Box>
    )
}

const GanttContentRow = ({day, actions, onGanttClick}) => {
    return (
        <Box sx={styles.contentRow}>
            <Box onDoubleClick={onGanttClick(day)} sx={{display: 'flex', alignItems: 'center', width: '100%', height: 25, backgroundColor: 'green', zIndex:1, position: 'relative'}}>
                {actions.map(action=>{
                    const position = calculatePosition(day, action.from, action.to)
                    return(
                        <Box onDoubleClick={(e)=>{e.stopPropagation()}}key={action._id}  sx={{ display: 'flex', boxShadow: 'inset 1px 0 0 0 rgba(255, 255, 255, 1)', position:'absolute', alignItems: 'center', color: 'white', zIndex:2, height:25, backgroundColor: 'red', ...position }}>
                            <Stack sx={{ml:1, width:'100%'}} direction="row" alignItems="center" >
                                <Typography sx={{mr: 2, fontSize:'14px'}}>{action.tenant.name}</Typography>
                                <Stack direction="row" justifyContent="space-between" flexGrow={1}>
                                    <Typography sx={{fontSize: '14px'}}>{dayjs(action.from).format('HH:mm')}</Typography>
                                    <Typography sx={{fontSize: '14px'}}>{dayjs(action.to).format('HH:mm')}</Typography>
                                </Stack>
                            </Stack>
                            
                        </Box>
                    )
                })}
                
                {/*<Box sx={{ display: 'flex', alignItems: 'center', width: '100%', color: 'white', height:25, backgroundColor: isOccupied ? 'red' : 'green'}}>{isOccupied ? isOccupied.tenant.name : ""}</Box>*/}
            </Box>

        </Box>
    )
}

const GanttHeadDayRow = () => {    
    return (
        <Box sx={styles.row}>
                <Stack direction="column" alignItems="center">
                </Stack>
        </Box>
    )
}

const GanttHeadContentRow = ({ intervals }) => {
    if (Array.isArray(intervals) && intervals.length >0) {
        return (
            <Box sx={styles.contentRow}>
                {intervals.map(interval => <Box key={`content-heading-${interval}`} sx={{display: 'flex', alignItems: 'center', width: 100 }}><Typography>{interval}</Typography></Box>)}
            </Box>
        )
    }
    return null;
}



const Gantt = () => {
    const navigate = useNavigate()
    const [actions, setActions] = useState([])
    const [openAddBooking, setOpenAddBooking] = useState(false)
    const [clickedDay, setClickedDay] = useState()
    const [clickedX, setClickedX] = useState()
    const [rate, setRate] = useState()
    const [shouldRefresh, setShouldRefresh] = useState(false)
    const [view, setView] = useState('full');
    const {setUserStore} = useContext(userContext)
    const days = Array.from({ length: 7 }, (_, index) =>
        dayjs().add(index, 'day').format('YYYY-MM-DD') // or any desired format
    );

    const intervals = getIntervals()

    const _getActions = async (from, to) => {
        try {
            const data = await getActions(from, to);
            setActions(transformData(data, days))
        } catch (e) {
            if(e.status === 401) {
                setUserStore(undefined);
                navigate('/login')
            }
        }
    }

    const getTurfDetails = async () => {
        try {
            const _rate = await getRate();
            setRate(_rate)
        } catch (e) {
            console.log(`error in getting rate`, e)
        }
    }
 
    useEffect(() =>{
        if (Array.isArray(days) && days.length > 1) {
            _getActions(days[0], days[days.length-1]);
        }
        getTurfDetails()
    }, [])

    useEffect(()=>{
        if (shouldRefresh) {
            setShouldRefresh(false);
            _getActions(days[0], days[days.length-1]);
        }
    }, [shouldRefresh])

    const onGanttClick =  (_day)=> {
        return (e) => {
            e.stopPropagation();
            const element = e.target;            
            const rect = element.getBoundingClientRect();
            const x = e.clientX - rect.left;
            setClickedDay(_day)
            setClickedX(x)
            setOpenAddBooking(true)
        }
    }

    const handleAddBookClick = () => {
        setClickedDay(dayjs().format('YYYY-MM-DD'))
        const minutesElapsedToday = dayjs().diff(dayjs().startOf('day'), 'minute');
        setClickedX(minutesElapsedToday)
        setOpenAddBooking(true)
    }

   return (
    <Box>
        <Typography sx={{width: '100%', textAlign: 'center', mt: 2, fontWeight: 'bold', fontSize: '1.4rem'}}>Dashboard</Typography>
        <ButtonBar view={view} setView={setView} handleAddBookClick={handleAddBookClick}/>
        {view === "full" ? (
            <Box sx={styles.container}>
                <Box sx={styles.day}>
                    <GanttHeadDayRow/>
                    {days.map(day =>(<GanttDayRow key={`book-day-${day}`} day={day}/>))}
                </Box>
                <Box sx={styles.content}>
                    <GanttHeadContentRow intervals={intervals}/> 
                    {days.map(day =>(<GanttContentRow key={`book-content-${day}`} day={day} onGanttClick={onGanttClick} intervals={intervals} actions={actions[day] || []}/>))}
                </Box>
            </Box> 
        ) :
        (<FitView days={days} intervals={intervals} actions={actions}/>)
    }
    {openAddBooking && <AddBooking
                        open={openAddBooking}
                        setOpen={setOpenAddBooking}
                        selectedDay={clickedDay}
                        x={clickedX}
                        rate={rate}
                        setShouldRefresh={setShouldRefresh}
                    />}
    </Box>
   ) 
}

const Home = () =>{
    const [selectedMenu, setSelectedMenu] = useState(0)
    return (
        <Box>            
            {selectedMenu === 0 && (<Gantt/>)}
            {selectedMenu === 1 && (<Report/>)}
            <Menu selectedMenu={selectedMenu} setSelectedMenu={setSelectedMenu}/>
        </Box>
    )
}

export default Home